import {t} from 'i18next';

const LogoutPage = () => {
  return (
    <div>
      <p>{t('header.logoutStateConfirmed')}</p>
    </div>
  );
};

export default LogoutPage;
